import { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Stack
} from '@chakra-ui/react'
import { acceptFriend, denyFriend, usersSelectors } from 'store'
import { NOTIFICATION_TYPE, PENDING } from 'utils/constants'
import { COLORS } from 'utils/styles'
import { v4 as uuid } from 'uuid'

import { BlockedRequestItems } from './BlockedRequestItems'

export const BlockedRequest = ({
  getFriendsNotificationsStatus,
  getBlockedRequestStatus
}) => {
  const {
    blockedRequest, acceptFriendStatus, denyFriendStatus, activeProfile
  } = useSelector(usersSelectors)
  const cardRef = useRef()
  const dispatch = useDispatch()
  const [selectId, setSelectId] = useState()

  const handleNotificationButton = ({ id, type }) => {
    if (type === NOTIFICATION_TYPE.Accept) {
      dispatch(acceptFriend({
        id,
        activeId: activeProfile?.id
      }))
    } else {
      dispatch(denyFriend({
        id,
        activeId: activeProfile?.id
      }))
    }
    setSelectId(id)
  }

  return (
    <Card key={uuid()} ref={cardRef} boxShadow="none" marginTop="0px !important" background="#c4c3c7">
      <CardHeader display="flex" alignItems="center" padding="0 10px" background="#feeb88">
        <Box textAlign="left" paddingRight="10px">
          Blocked Profiles
        </Box>
      </CardHeader>

      <CardBody padding="5px" minHeight="130px">
        <Box
          sx={{
            overflowX: 'auto',
            display: 'flex',
            flexDirection: 'row',
            gap: '10px',
            paddingBottom: '5px'
          }}
          css={{
            '&::-webkit-scrollbar': {
              width: '4px',
              height: '10px',
              display: 'block'
            },
            '&::-webkit-scrollbar-track': {
              width: '6px'
            },
            '&::-webkit-scrollbar-thumb': {
              borderRadius: '24px',
              background: 'rgba(255, 215, 0, 1)'
            }
          }}
        >
          {blockedRequest?.length ? (
            <BlockedRequestItems
              notifications={blockedRequest}
              handleNotificationButton={handleNotificationButton}
              getFriendsNotificationsStatus={getFriendsNotificationsStatus}
              getBlockedRequestStatus={getBlockedRequestStatus}
              isAcceptLoading={acceptFriendStatus === PENDING}
              isRejectLoading={denyFriendStatus === PENDING}
              selectId={selectId}
            />
          ) : <div>No notifications to display</div>}
          {/* <ContentItem items={item?.value} title={item?.id} /> */}
        </Box>
      </CardBody>
    </Card>
  )
}
